import { getViolationRsvList } from "apis/meetings/attendee-limit-violation";
import { TViolationRsvListItem } from "./types";

export class ViolationRsvListServices {
  constructor() {}

  //* INFO: 최소 참석 인원 위반 예약 조회
  async getViolationRsvList(
    startDate: Date,
    endDate: Date,
    page: number
  ): Promise<{ list: TViolationRsvListItem[]; totalPageNumber: number; success: boolean }> {
    //* startDate 시간 필터를 00분 00초로 설정
    startDate.setHours(0, 0, 0, 0);

    //* endDate 시간 필터를 23시 59분 59초로 설정
    endDate.setHours(23, 59, 59, 999);
    const list = await getViolationRsvList(startDate, endDate, page);
    if (list.success && list.data) {
      return { success: true, list: list.data.attendeeLimitViolationList ?? [], totalPageNumber: list.data?.totalPageNumber };
    } else {
      return { success: false, list: [], totalPageNumber: 0 };
    }
  }
}
